import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router v6 keeps scroll position across route changes by
// default — the operator wants each tab to open from the top like a
// native app.
//
// The admin's CSS sets `html, body, #root { height: 100% }` which
// makes the scrolling element browser-dependent (some engines scroll
// the documentElement, some the body, some an inner container).
// Reset every plausible container so this behaves the same on
// Chrome, Firefox, Safari, and Edge — including a rAF pass so the
// reset also lands after the new route's initial paint (some pages
// mount taller content in a follow-up effect that would restore
// mid-scroll if we only reset once).
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const reset = () => {
      try { window.scrollTo({ top: 0, left: 0, behavior: 'auto' }); } catch { /* older browsers */ }
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      const main = document.querySelector('main');
      if (main) main.scrollTop = 0;
      const app = document.querySelector('.app');
      if (app) app.scrollTop = 0;
    };

    reset();
    // A second pass after the browser paints — catches pages that
    // mount their tall content in a follow-up effect (data fetch,
    // conditional render) which would otherwise land mid-scroll.
    const raf = requestAnimationFrame(reset);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
}
